<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="onClearFilters()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Type de rejet</mat-label>
              <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings" [data]="dropdownListRejectionFlag"
                (onDeSelect)="filterInvoices()" (onSelect)="filterInvoices()" placeholder='Sélectionner...'
                (onDeSelectAll)="onSelectAll($event, 'RejectionFlag')"
                (onSelectAll)="onSelectAll($event, 'RejectionFlag')" [(ngModel)]="selectedItemsRejectionFlag" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Facture prise en charge</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsPicked"
                [data]="dropdownListPicked" (onSelect)="filterInvoices()" placeholder='Sélectionner...'
                (onSelectAll)="onSelectAll($event,'Picked')" (onDeSelectAll)="onSelectAll($event, 'Picked')"
                (onDeSelect)="filterInvoices()" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Groupe</mat-label>
              <ng-multiselect-dropdown placeholder="" [settings]="dropdownMultiSelectWithSearchSettings"
                [data]="dropdownListGroups" (onDeSelect)="onGroupsChange()" (onSelect)="onGroupsChange()"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'Groups')"
                (onSelectAll)="onSelectAll($event, 'Groups')" [(ngModel)]="selectedItemsGroups" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Num&eacute;ro de facture</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="filterInvoices()" [(ngModel)]="invoiceSearchCriteriaModel.Number">
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Nom du fournisseur</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="filterInvoices()" [(ngModel)]="invoiceSearchCriteriaModel.SupplierName">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>R&eacute;f&eacute;rence 1</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownMultiSelectWithSearchSettings"
                [data]="assetsDropdownList" (onFilterChange)="onAssetFilterChange($event)"
                (onDeSelect)="filterInvoices()" (onSelect)="filterInvoices()" placeholder='Sélectionner...'
                (onDeSelectAll)="onSelectAll($event, 'Assets')" (onSelectAll)="onSelectAll($event, 'Assets')"
                [(ngModel)]="selectedAssetsItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Soci&eacute;t&eacute; factur&eacute;e</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownMultiSelectWithSearchSettings"
                [data]="recipientEntitiesDropdownList" (onFilterChange)="onRecipientEntityFilterChange($event)"
                (onDeSelect)="filterInvoices()" (onSelect)="filterInvoices()"
                (onDeSelectAll)="onSelectAll($event, 'RecipientEntity')"
                (onSelectAll)="onSelectAll($event, 'RecipientEntity')" placeholder='Sélectionner...'
                [(ngModel)]="selectedRecipientEntitiesItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de r&eacute;ception</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromReceptionDate"
              [valueFrom]="invoiceSearchCriteriaModel.FromReceptionDate"
              typeTo="ToReceptionDate"
              [valueTo]="invoiceSearchCriteriaModel.ToReceptionDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Situation de travaux</mat-label>
              <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings"
                [data]="dropdownListWorkingSituation" (onDeSelect)="filterInvoices()"
                (onSelect)="filterInvoices()" placeholder='Sélectionner...'
                (onDeSelectAll)="onSelectAll($event, 'WorkingSituation')"
                (onSelectAll)="onSelectAll($event,'WorkingSituation')"
                [(ngModel)]="selectedItemsWorkingSituation" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" >
              <input matInput type="text" hidden>
              <mat-label>Reverse factoring</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsReverseFactoring"
                [data]="dropdownListReverseFactoring" (onSelect)="filterInvoices()" placeholder='Sélectionner...'
                (onSelectAll)="onSelectAll($event,'ReverseFactoring')"
                (onDeSelectAll)="onSelectAll($event, 'ReverseFactoring')"
                (onDeSelect)="filterInvoices()" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-invoice-list [(data)]="data" [tableRowsActions]="tableActions" [tableIndications]="tableIndications"
  [pageIndex]="pageIndex" [onFiltersCleared]="onFiltersCleared" [onExportExcelCaller]="onExportExcelCaller" [exportFileName]="exportFileName" [canDownload]="false"
  [configKey]="configKey" ngDefaultControl>
</app-invoice-list>
